import { UnaryFunction } from 'rxjs/interfaces';
import { debounceTime, buffer } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';

export const debounceBufferTime = <T>(timeout: number = 0): UnaryFunction<Observable<T>, Observable<T[]>> => s =>
  buffer<T>(debounceTime(0)(s))(s);
